import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, IconButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

type ExpandMoreButtonProps = IconButtonProps & {
  expand: boolean;
  'data-testid'?: string;
};

export const ExpandMoreButton = styled((props: ExpandMoreButtonProps) => {
  const { expand, ...other } = props;
  return (
    <IconButton {...other}>
      <ExpandMoreIcon />
    </IconButton>
  );
})(({ theme }) => ({
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: 'rotate(0deg)'
      }
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: 'rotate(180deg)'
      }
    }
  ]
}));
